import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { iconButtonPillStyle } from './iconButtonPillStyle';

type CloseButtonProps = {
  onClose: () => void;
};

const CloseButton: React.FunctionComponent<CloseButtonProps> = ({ onClose }: CloseButtonProps) => {
  return (
    <IconButton onClick={onClose} aria-label="close" sx={iconButtonPillStyle}>
      <CloseIcon />
    </IconButton>
  );
};

export default CloseButton;
